import { useCallback } from "react";
import Analytics from "analytics";

/**
 * useTrack — returns a stable track(eventName, props) function.
 * Thin wrapper around Analytics.track for ergonomic use inside components.
 *
 *   const track = useTrack();
 *   track(EVENTS.HOMEPAGE_CTA_CLICKED, { cta_location: "hero", destination: "/signup" });
 */
export const useTrack = () => {
  return useCallback((eventName, props) => {
    Analytics.track(eventName, props);
  }, []);
};
